const Util = require('@antv/f2/lib/util/common')

const _isFiltered = (scale, values, value) => values.some(d => scale.getText(d) === scale.getText(value))

class ChartDetailLegend {
  static getDefaultCfg() {
    return {
      legendsUpdate: null,
    }
  }
  constructor(cfg) {
    Util.mix(this, cfg)
  }
  
  clear() {
    // this.legendsUpdate = null
    // this.chart = null
  }
}

/**
 * 用于每次单图重绘时更新 legends 到单图中
 */
export default {
  init(chart) {
    const controller = new ChartDetailLegend({
      chart,
    })

    chart.set('chartDetailLegendController', controller)

    chart.setLegendUpdater = (fn) => {
      if (!Util.isFunction(fn)) return this

      controller.legendsUpdate = fn
      return this
    }
  },

  beforeGeomDraw(chart) {
    const legendItems = chart.getLegendItems()
    const scales = chart.get('scales')
    const filters = chart.get('filters')

    const legends = {}

    Util.each(legendItems, (items, field) => {
      const scale = scales[field]
      const { values } = scale
      let filteredVals
      if (filters && filters[field]) {
        filteredVals = values.filter(v => !filters[field](v))
      } else {
        filteredVals = []
      }

      items.forEach((item) => {
        if (Array.isArray(filteredVals)) {
          item.checked = !_isFiltered(scale, filteredVals, item.dataValue)
        }
      })
      legends[field] = items
    })
  
  
    const controller = chart.get('chartDetailLegendController')
  
    if (controller && Util.isFunction(controller.legendsUpdate)) {
      controller.legendsUpdate(legends)
    }
  },
  
  clearInner(chart) {
    const controller = chart.get('chartDetailLegendController')
    controller && controller.clear()
  }
}
